import React from 'react';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

export default class Sombrero extends PositionedGoodyHOC {
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="95.62737" cy="54.79403" />
				<path fill="#FF9D5A" d="M96.62782,40.91937c-26.72363,0-49.50966-0.81818-65.89526-2.36634
					C6.17045,36.2323,4.92638,33.09066,4.92638,32.48447s1.24407-3.74783,25.80619-6.06825
					c16.3856-1.54847,39.17252-2.36665,65.89526-2.36665s49.50876,0.81818,65.89435,2.36665
					c24.56212,2.32042,25.8062,5.46206,25.8062,6.06825s-1.24408,3.74783-25.8062,6.06856
					C146.13748,40.10119,123.35146,40.91937,96.62782,40.91937z" />
				<path fill="#FC5959" d="M31.15308,30.86395c16.24463-1.53519,38.8855-2.34668,65.47478-2.34668
					c26.58846,0,49.22906,0.81149,65.47395,2.34668c5.58394,0.52764,9.82793,1.08717,13.0461,1.62053h13.18051
					c0-0.60617-1.24423-3.74798-25.80641-6.06821c-16.38559-1.54855-39.17153-2.36659-65.89415-2.36659
					c-26.72289,0-49.50965,0.81804-65.89525,2.36659C6.17043,28.73651,4.92646,31.87832,4.92646,32.48449h13.18025
					C21.32488,31.95113,25.56887,31.39159,31.15308,30.86395z" />
				<path fill="#FFCE8D" d="M130.78563,46.09406c0-18.32381-15.82668-45.52703-34.15049-45.52703H96.6196
					c-18.32381,0-34.15048,27.20323-34.15048,45.52703H130.78563z" />
				<path fill="#FFCE8D" d="M162.52203,38.02269c-16.38451,1.41298-39.17043,2.15953-65.89412,2.15953
					s-49.50961-0.74656-65.8952-2.15953C6.17056,35.90472,4.92632,33.0377,4.92632,32.4845
					c0,18.03426,10.74112,31.23459,91.70106,31.23459s91.70104-13.20033,91.70104-31.23459
					C188.32841,33.0377,187.08418,35.90472,162.52203,38.02269z" />
				<circle fill="#FFFFFF" cx="47.98237" cy="46.88966" r="3.56067" />
				<circle fill="#FFFFFF" cx="72.30487" cy="47.83371" r="3.56067" />
				<circle fill="#FFFFFF" cx="24.77766" cy="45.14322" r="3.56067" />
				<circle fill="#FFFFFF" cx="3.80853" cy="41.63413" r="3.56068" />
				<circle fill="#FFFFFF" cx="96.62737" cy="48.20508" r="3.56067" />
				<circle fill="#FFFFFF" cx="145.27237" cy="46.88966" r="3.56067" />
				<circle fill="#FFFFFF" cx="120.94987" cy="47.83371" r="3.56067" />
				<circle fill="#FFFFFF" cx="168.47708" cy="45.14322" r="3.56067" />
				<circle fill="#FFFFFF" cx="189.44621" cy="41.63413" r="3.56068" />
				<path fill="#FC5959" d="M162.10181,34.1053c-16.24489,1.53491-38.8855,2.34641-65.47395,2.34641
					c-26.58819,0-49.22906-0.8115-65.47505-2.34641c-5.58394-0.52764-9.82792-1.08745-13.04609-1.62081H4.92646
					c0,0.60617,1.24397,3.74771,25.80614,6.06849c16.3856,1.54827,39.17154,2.36631,65.89525,2.36631
					c26.72343,0,49.50964-0.81804,65.89415-2.36631c24.56218-2.32078,25.80641-5.46232,25.80641-6.06849H175.1479
					C171.92973,33.01785,167.68575,33.57766,162.10181,34.1053z" />
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Hat/Sombrero.js